import { get as _get } from 'lodash';
import * as api from '../common/api/solunar';
import { NOT_FOUND, INTERNAL_SERVER_ERROR } from './status';

export const FETCH_SOLUNAR = 'FETCH_SOLUNAR';
export const FETCH_SOLUNAR_SUCCESS = 'FETCH_SOLUNAR_SUCCESS';
export const FETCH_SOLUNAR_FAILURE = 'FETCH_SOLUNAR_FAILURE';

export const fetchSolunar = coordinates => async (dispatch, state) => {
  dispatch({
    type: FETCH_SOLUNAR,
  });
  try {
    const userStateDetails = _get(state(), 'user.details', {});
    const solunar = await api.fetchSolunar(coordinates[0], coordinates[1], userStateDetails);
    await dispatch({
      type: FETCH_SOLUNAR_SUCCESS,
      solunar,
    });
  } catch (error) {
    dispatch({
      type: FETCH_SOLUNAR_FAILURE,
      error,
    });
    if (error.statusCode >= 400 && error.statusCode < 500) {
      dispatch({
        type: NOT_FOUND,
        message: `Solunar for ${coordinates} could not be found`,
      });
    } else {
      dispatch({
        type: INTERNAL_SERVER_ERROR,
        message: `Solunar for ${coordinates} error`,
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/actions/solunar.js